import { connect } from 'react-redux';
import { fetchIndustriesIfNeeded } from 'common/ducks/industry';
import { showBanner, hideBanner } from 'common/ducks/banner';
import { resendValidationEmail } from 'common/ducks/user';
import { fetchCounts } from 'your_projects/ducks';
import YourProjects from 'your_projects/components';

const mapStateToProps = ({ user }) => {
  return {
    user: user.profile_data,
  };
}

export default connect(mapStateToProps, {
  fetchIndustriesIfNeeded,
  showBanner,
  hideBanner,
  resendValidationEmail,
  fetchCounts
})(YourProjects);



// WEBPACK FOOTER //
// ./your_projects/containers/index.js